<template>    
     <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                    :content_align_x="'justify-content-start'"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'parent_id',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
        "maximum_order"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            first_time: true
        }
    },
    
    methods:{
        async setup()
        {
            this.first_time = true
            this.getDailyAssignments()
        },
        async getDailyAssignments()
        {
            if(!this.array_options['daily_assignment_id'])
            {
                this.loader(true)
            }

            const res = await this.get(`general_functions/assignments`)

            if(res.status)
            {
                this.$emit('updateArrayOptions', {daily_assignment_id: res.data.daily_assignments})
            }
            else
            {
                this.error_handling(res)
            }

            this.loader()
        },

        async getDutyNotesMinutes(daily_assignment_id)
        {
            const res = await this.post(`${this.rest_api}/get/minutes_from_duty_notes`, {daily_assignment_id})

            if(res.status)
            {
                this.single_object.daily_minutes = res.data.minutes
            }
            else
            {
                this.error_handling(res)
            }
        },
    },

    watch: {

        "single_object.frequency_week" (newVal, oldVal) {
            if (newVal) {
                if (newVal <= 0) {
                    this.single_object.frequency_week = oldVal
                    this.notyf.error('Frecuency Week must be greater than 0')
                } else {
                    this.single_object.annual_minutes = this.single_object.daily_minutes ? (this.single_object.daily_minutes * newVal * 52).toFixed(2) : '' 
                }
            } else {
                this.single_object.annual_minutes = ''
            }
        },

        "single_object.daily_minutes" (newVal) {
            if (newVal) {
                
                newVal = newVal.toString();
        
                let parts = newVal.split('.');
                
                if (parts.length > 1) 
                {
                    parts[1] = parts[1].substring(0, 2);
                }
                
                newVal = parts.join('.');
                
                this.single_object.daily_minutes = newVal

                this.single_object.annual_minutes = this.single_object.frequency_week ? (this.single_object.frequency_week * newVal * 52).toFixed(2) : ''
                
            } else {
                this.single_object.annual_minutes = ''
            }
        },

        "single_object.from_assignment_notes"(newVal)
        {
            
                if(!newVal)
                {
                    this.form_format = FormResources.form_format
                }
                else
                {
                    this.form_format = FormResources.form_format_2
                    if(!this.first_time)
                    {
                        this.getDailyAssignments()
                    }
                }
        },
        'single_object.daily_assignment_id': {
            handler(val) {
                if(!this.first_time)
                {
                    this.getDutyNotesMinutes(val);
                }

                this.first_time = false
            },
            deep: true
        }
    },

    mounted(){

    }
    
}
</script>